// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardCartContainer {
  width: 100%;
  display: flex;
  align-items: start;
  justify-content: space-between;
  padding: 1rem;
  border: 1px solid #DCDFE1;
  border-radius: 0.5rem;
  box-shadow: none;
  margin-bottom: 0.5rem;
}
.cardCartContainer > * img {
  width: 100px;
  height: auto;
  border-radius: 0.5rem;
}

.flexEndGridContainer {
  display: flex;
  align-items: center;
  justify-content: end;
}

.offContainer {
  width: fit-content;
  background-color: #CC0056;
  border-radius: 0.4rem;
  padding: 0 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.countContainer {
  margin-top: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0.4rem;
  border: 1px solid #FF6B00;
  padding: 0.4rem;
}

.contentContainer {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  gap: 0.5rem;
}

.priceContainer {
  font-size: 0.7rem;
  text-decoration: line-through;
  line-height: 0.8rem;
}

.unit {
  font-size: 0.8rem;
  font-style: italic;
  color: #6A6E73;
}

.cartDescription {
  font-size: 0.6rem !important;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2rem;
  text-align: right;
  padding-right: 0.1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Card/CartCard/cart.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;AACF;AACE;EACE,YAAA;EACA,YAAA;EACA,qBAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;AAAF;;AAGA;EACE,iBAAA;EACA,6BAAA;EACA,mBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;AAAF;;AAGA;EACE,4BAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAAF","sourcesContent":[".cardCartContainer {\n  width: 100%;\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  padding: 1rem;\n  border: 1px solid #DCDFE1;\n  border-radius: 0.5rem;\n  box-shadow: none;\n  margin-bottom: 0.5rem;\n\n  > * img {\n    width: 100px;\n    height: auto;\n    border-radius: 0.5rem;\n  }\n}\n\n.flexEndGridContainer {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n\n.offContainer {\n  width: fit-content;\n  background-color: #CC0056;\n  border-radius: 0.4rem;\n  padding: 0 0.4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.countContainer {\n  margin-top: 0.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 0.4rem;\n  border: 1px solid #FF6B00;\n  padding: 0.4rem;\n}\n\n.contentContainer {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  gap: 0.5rem;\n}\n\n.priceContainer {\n  font-size: 0.7rem;\n  text-decoration: line-through;\n  line-height: 0.8rem;\n}\n\n.unit {\n  font-size: 0.8rem;\n  font-style: italic;\n  color: #6A6E73;\n}\n\n.cartDescription {\n  font-size: 0.6rem !important;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.2rem;\n  text-align: right;\n  padding-right: 0.1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
